module.exports = __webpack_public_path__ + "static/media/HomeNavIcon.c3c97464.svg";